module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0096.jpg?v=642fd371";